@if (displayData) {
<ng-container *rbac="rbacProperty; else pureTpl">
  <a [routerLink]="link" [ngClass]="customClass" class="id">
    {{ displayData }}
  </a>
</ng-container>
<ng-template #pureTpl>
  <span class="id">{{ displayData }}</span>
</ng-template>
@if (!showCopiedMessage) {
<span p500UITooltip tooltipData="Copy to clipboard" i18n-tooltipData="@@common.copy_to_clipboard" (click)="copy($event)">
  <p500-ui-icon name="copy" class="cursor-pointer"></p500-ui-icon>
</span>
} @else {
<span p500UITooltip i18n-tooltipData="@@common.copied_to_clipboard" tooltipData="Copied to clipboard" (click)="copy($event)">
  <p500-ui-icon name="copy" class="cursor-pointer"></p500-ui-icon>
</span>
} } @else {
<gtd-ui-field-empty-component></gtd-ui-field-empty-component>
}
